import React, { useReducer, useEffect } from "react";
let reducer = (data, newData) => {
  return { ...data, ...newData };
};
const intialState = {
  token: "",
  company: {
    uuid: "",
    reference_id: "",
    name: ""
  },
  client: {
    uuid: "",
    name: "",
    reference_id: ""
  }
};
const sessionState = JSON.parse(sessionStorage.getItem("data"));
export const SessionContext = React.createContext();
export function SessionProvider(props) {
  const [data, setData] = useReducer(reducer, intialState || sessionState);
  useEffect(() => {
    sessionStorage.setItem("data", JSON.stringify(data));
  }, [data]);
  return (
    <SessionContext.Provider value={{ data, setData }}>
      {props.children}
    </SessionContext.Provider>
  );
}
//export {CompanyContext, CompanyProvider}
